export const MANAGER_DETAILS_TAB_PARAM = "tab";

export const MANAGER_DETAILS_TABS = {
  GENERAL_DATA: "dados-gerais",
  USERS: "usuarios",
} as const;
